
import { Component, Vue } from 'vue-property-decorator'
import { getAgencyMsg,readMessageIt } from '@/apis/myInfo/myInfo';

@Component({
  components: {

  },
})
export default class SchoolMsg extends Vue {
  private detailData:any = null;
  private msgId:string = "";
  private msgType:number = 0;

  readIt(){
    readMessageIt({id:this.msgId}).then((res:any)=>{});
  }

  created() {
    this.msgId   = this.$route.query.id as string;
    this.msgType = Number(this.$route.query.type);
    getAgencyMsg({id:this.msgId,type:this.msgType}).then((res:any)=>{
      this.detailData = res;
      this.readIt();
      this.$forceUpdate();
    });
    //阅读掉这条消息
  }
}
